import { normalize } from 'normalizr'
import qs from 'qs'
import axios from 'axios'
import {
  SEND_ALERT,
  CLOSE_ALERT,
  SUBMITTING_FORM,
  FORM_SUBMITTED,
  FORM_SUBMIT_FAILED,
  SUBSCRIBING_USER,
  USER_SUBSCRIBED,
  FAILED_SUBSCRIBING_USER,
  ADDING_NEW_SUPPLEMENT,
  ADDING_NEW_SUPPLEMENT_FAILED,
  ADDED_NEW_SUPPLEMENT,
  FETCHING_SUPPLEMENTS,
  FETCHING_SUPPLEMENTS_FAILED,
  FETCHED_SUPPLEMENTS,
} from '../constants'
import { supplementsEntity } from 'config/normalizrSchema'
import generateCorsAnywhereUrl from 'utils/generateCorsAnywhereUrl'

export function sendAlert({ message, type }) {
  return {
    type: SEND_ALERT,
    alert: { message, type },
  }
}

export function closeAlert() {
  return {
    type: CLOSE_ALERT,
  }
}

export function submitForm({ formName, values }) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SUBMITTING_FORM, values })
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: '/',
        data: qs.stringify({ 'form-name': formName, ...values }),
      })
        .then(({ status }) => {
          if (status === 200) {
            dispatch({ type: FORM_SUBMITTED, formName, ...values })
            resolve({ formName, ...values })
          } else {
            dispatch({ type: FORM_SUBMIT_FAILED, formName, ...values })
            reject()
          }
        })
        .catch((error) => {
          console.error(error)
          dispatch({ type: FORM_SUBMIT_FAILED, formName, error, ...values })
          reject(error)
        })
    })
  }
}

export function subscribe({ campaignToken, ...values }) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!campaignToken) {
        throw new Error(
          'You need to pass a valid campaign token in order to subscribe users',
        )
      }
      dispatch({ type: SUBSCRIBING_USER, values })
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: generateCorsAnywhereUrl(process.env.SUBSCRIBE_URL),
        data: qs.stringify({ campaign_token: campaignToken, ...values }),
      })
        .then(({ status }) => {
          if (status === 200) {
            dispatch({ type: USER_SUBSCRIBED, campaignToken, ...values })
            resolve({ campaignToken, ...values })
          } else {
            dispatch({
              type: FAILED_SUBSCRIBING_USER,
              campaignToken,
              ...values,
            })
            reject()
          }
        })
        .catch((error) => {
          dispatch({
            type: FAILED_SUBSCRIBING_USER,
            campaignToken,
            error,
            ...values,
          })
          reject(error)
        })
    })
  }
}

export function fetchSupplements() {
  return (dispatch, _, { dynamoDb }) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: FETCHING_SUPPLEMENTS })
      dynamoDb.scan(
        { TableName: 'weight_loss_supplements' },
        (error, { Items }) => {
          if (error) {
            dispatch({ type: FETCHING_SUPPLEMENTS_FAILED, error })
            reject(error)
          } else {
            const { entities } = normalize(Items, [supplementsEntity])
            dispatch({
              type: FETCHED_SUPPLEMENTS,
              supplements: entities.supplements,
            })
            resolve(Items)
          }
        },
      )
    })
  }
}

export function addSupplement(values) {
  return (dispatch, _, { dynamoDb }) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ADDING_NEW_SUPPLEMENT, values })
      dynamoDb.put(
        { TableName: 'weight_loss_supplements', Item: values },
        (error, data) => {
          if (error) {
            dispatch({ type: ADDING_NEW_SUPPLEMENT_FAILED, error })
            reject(error)
          } else {
            dispatch({ type: ADDED_NEW_SUPPLEMENT, supplement: data })
            resolve(data)
          }
        },
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/app.js